export default __webpack_public_path__ + "static/media/slide-close.cd8a9f55.svg";